import { render, staticRenderFns } from "./EditFamily.vue?vue&type=template&id=6235e354&"
import script from "./EditFamily.vue?vue&type=script&lang=js&"
export * from "./EditFamily.vue?vue&type=script&lang=js&"
import style0 from "./EditFamily.vue?vue&type=style&index=0&id=6235e354&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports